export type ApplicationEntry = 'debug' | 'product' | 'desktop-handoff'

export interface DeviceSignals {
  userAgent: string
  platform: string
  maxTouchPoints: number
}

const DEBUG_ONLY_PARAMETERS = [
  'debug',
  'mode',
  'specimen',
  'reticle_stabilization',
  'provisional_reticle',
  'xr_scale',
  'heart',
] as const

export function isDebugEntry(search: string): boolean {
  return new URLSearchParams(search).get('debug') === 'true'
}

export function isMobileOrTabletDevice(signals: DeviceSignals): boolean {
  const mobileUserAgent = /Android|iPhone|iPad|iPod/i.test(signals.userAgent)
  const touchMac = signals.platform === 'MacIntel' && signals.maxTouchPoints > 1
  return mobileUserAgent || touchMac
}

export function selectApplicationEntry(
  search: string,
  signals: DeviceSignals,
): ApplicationEntry {
  if (isDebugEntry(search)) return 'debug'
  return isMobileOrTabletDevice(signals) ? 'product' : 'desktop-handoff'
}

export interface CleanProductUrlOptions {
  retainDebugParameters?: boolean
}

export function cleanProductUrl(
  source: URL,
  options: CleanProductUrlOptions = {},
): URL {
  const result = new URL(source.href)
  if (!options.retainDebugParameters) {
    for (const parameter of DEBUG_ONLY_PARAMETERS) result.searchParams.delete(parameter)
  }
  return result
}
